<template>
  <div :class="{ deleted: message.deleted }" class="e-chat__message">
    <div
      class="e-chat__message__content"
    >
      <div class="e-chat__message__preview" v-for="attachment in message.attachments" :key="attachment.id">
        <div v-if="attachment.filename.split('.').pop() === 'pdf'" class="pdf">
          <IconPDF class="pdf-icon" />
          <a target="_blank" :href="attachmentLink(attachment.id)">{{ attachment.filename }}</a>
        </div>
        <div v-else-if="attachment.filename.split('.').pop() === 'jpg' ||
                        attachment.filename.split('.').pop() === 'jpeg' ||
                        attachment.filename.split('.').pop() === 'png'" class="image">
          <a target="_blank" :href="attachmentLink(attachment.id)">
            <img 
              :src="downloadLink(attachment.id)"
              alt="preview"
              loading="lazy"
              style="max-width: 200px;max-height: 300px"/>
          </a>
        </div>
      </div>
      <span class="e-chat__message__text" v-html="message.text" />
    </div>
    
    <div class="e-chat__message__date">
      <time :datetime="message.createdAt">
        {{
          (typeof message.createdAt === 'object'
            ? message.createdAt.toISOString()
            : message.createdAt) | time
        }}
      </time>
    </div>
    <IconTrash
      v-if="deletable"
      class="e-chat__message-delete"
      @click="deleteMessage"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from 'api'
import { restapi } from 'api/config'
import IconTrash from 'assets/icons/minus.svg'
import IconPDF from 'assets/icons/pdf_icon.svg'
export default {
  components: {
    IconTrash,
    IconPDF
  },
  props: {
    message: {
      default: () => ({}),
      type: Object
    },
    deletable: {
      default: false,
      type: Boolean
    },
    chatId: {
      type: String
    },
  },
  computed: mapGetters(['currentUserChat', 'userInfo']),
  methods: {
    deleteMessage() {
      this.$confirm('Nachricht löschen', this.$t('system.warning'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      })
        .then(() => {
          api.call('deleteChatMessage', {
            id: this.message.id,
            rootId: this.currentUserChat.id
          })
        })
        .catch(() => {})
    },

    attachmentLink(attachmentId) {
      if(attachmentId) {
        if(restapi[process.env.NODE_ENV]){
          return `${restapi[process.env.NODE_ENV].url}/chat/${this.userInfo.id}/${this.chatId}/message/${this.message.id}/attachments/${attachmentId}/view`
        }
      }
      return ""
    },
    downloadLink(attachmentId) {
      if(attachmentId) {
        if(restapi[process.env.NODE_ENV]){
          return `${restapi[process.env.NODE_ENV].url}/chat/${this.userInfo.id}/${this.chatId}/message/${this.message.id}/attachments/${attachmentId}/download`
        }
      }
      return ""
    },
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/ChatMessage';
</style>
